export default "__VITE_ASSET__BdZYWzYS__"